import React, {Fragment} from 'react';
import RecipeList from '../RecipeList';
import {gtmSend} from '../../../helpers';
import cx from '../../../styles';

const RelatedRecipes = (props) => {

	const clickHandler = (slug, id) => {
		gtmSend('dynamic event', 'Recipes', 'Related recipes click', `/${slug}/${id}`);
		window.scrollTo(0,0);
	}

	return (
		<Fragment>
			{
				props.related &&
				<div className={cx('related-recipes-wrap', 'shadow-card')}>
					<div className={cx('title')}>{props.t('related_recipes')}</div>
					<RecipeList recipes={props.related} clickHandler={clickHandler} isShowLess={true} />
				</div>
			}
		</Fragment>
	)
}

export default RelatedRecipes;